import { Container as DesignContainer } from 'design-react-kit/dist/design-react-kit';

/*This component facilitates the customization of Container*/

const Container = props => {
  return <DesignContainer {...props} />;
};

export default Container;
